export default __webpack_public_path__ + "static/media/app-landing-image-01.63645eb4.png";